// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nth {\n  vertical-align: top;\n}\n.row-pointer > .v-data-table__wrapper > table > tbody > tr :hover {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
